import { openDB } from 'idb';
import { SubmissionPayload } from '../types';

const DB_NAME = 'function-checks';
const OUTBOX_STORE = 'outbox';
const TOOLBOX_OUTBOX_STORE = 'toolbox-outbox';

type OutboxRecord = {
  id?: number;
  queuedAt: string;
  payload: SubmissionPayload;
};

async function getDb() {
  return openDB(DB_NAME, 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(OUTBOX_STORE)) {
        db.createObjectStore(OUTBOX_STORE, { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(TOOLBOX_OUTBOX_STORE)) {
        db.createObjectStore(TOOLBOX_OUTBOX_STORE, { keyPath: 'id', autoIncrement: true });
      }
    }
  });
}

export async function addToOutbox(payload: SubmissionPayload): Promise<number> {
  const db = await getDb();
  const id = await db.add(OUTBOX_STORE, { payload, queuedAt: new Date().toISOString() });
  return id as number;
}

export async function readOutbox(): Promise<OutboxRecord[]> {
  const db = await getDb();
  return db.getAll(OUTBOX_STORE) as Promise<OutboxRecord[]>;
}

export async function removeFromOutbox(id: number): Promise<void> {
  const db = await getDb();
  await db.delete(OUTBOX_STORE, id);
}
